<template>
  <div class="user-list">
    <light-box
      v-if="migrateUser"
      class="migrate-popup"
      @close="onCloseMigration">

      <div
        class="container"
        slot="light-box-content">

        <sqwiz-migration
          :user-id="migrateUser"
          @close="onCloseMigration" />

      </div>
    </light-box>

    <pagination-navigation class="p-0 p-md-3" :paginationInfo="getPaginationInfo" @prevpage="prevPage" @nextpage="nextPage">
      <div
        slot="filterSlot">
        <input-text
          iconRight="search"
          small
          regular
          variant="standardInput"
          :inputPlaceholder="$t('Administration.userList.findUser')"
          inputName="query"
          @fieldUpdate="updateFilter" />

      </div>
    </pagination-navigation>

    <div class="users">
      <user-table :userList="getUserList"/>
      <div class="text-center m-3">
        <q-icon
          v-if="$apollo.loading"
          :allowSelfUpdate="false"
          spin
          width="110px"
          name="spinner" />

      </div>
    </div>

    <pagination-navigation class="p-0 p-md-3" :paginationInfo="getPaginationInfo" @prevpage="prevPage" @nextpage="nextPage"/>
  </div>
</template>

<script>
import userList from '@/mixins/pagination/providers/userList'
import UserTable from '@/components/service/administration/users/UserTable'
import QIcon from '@/components/standard/display/QIcon'
import Lightbox from '@/components/standard/display/Lightbox'
import SqwizMigration from '@/components/standard/display/migration/sqwiz/Interface'
import PaginationNavigation from '@/components/standard/pagination/PaginationNavigation'
import InputText from '@/components/standard/input/InputText'

export default {
  methods: {
    onCloseMigration () {
      this.$router.push({ name: 'UserList' })
    },

    updateFilter (e) {
      this.page = 0
      this.query = e.value
    },
  },

  computed: {
    migrateUser () {
      return this.$route.query.migrate
    },

    getUserList () {
      if (this.$apollo.loading) return []
      if (this.query) return this.getSearchedUsers
      return this.userList
    },
  },

  components: {
    'user-table': UserTable,
    'q-icon': QIcon,
    'light-box': Lightbox,
    SqwizMigration,
    PaginationNavigation,
    InputText,
  },
  mixins: [
    userList,
  ]
}
</script>

<style scoped>
.statistics-overlay {
  position: fixed;
  top: 90px;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: rgba(30, 30, 30, 0.6);
}
.statistics-container {
  background-color: white;
  border-radius: 10px;
  margin: 10px;
  padding: 30px 20px;
  box-shadow: 0 0 5px #1E1E1E;
}
.danger {
  background-color: rgba(255, 50, 100, 0.5)!important;
}
.users {
  text-align: right;
  margin-top: 20px;
}
.pointer {
  cursor: pointer;
}
.search-box {
  width: 250px;
}
</style>



// WEBPACK FOOTER //
// src/components/service/administration/users/UserList.vue?0bd5ee2a